import Styles from './LabInfo.module.scss';
// module imports.
import { ListItem, ListItemText, ListItemAvatar, Avatar, Paper, Tooltip } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ExtensionIcon from '@mui/icons-material/Extension';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

// Components import.
import { useTranslation } from 'components/lib'

export function LabInfo(props) {

    const { t } = useTranslation();
    return (
        <>
            <Tooltip title={t('Labs.UserNodes.labInfo.tooltip.quizScore')}>
                <Paper elevation={3} sx={{ width: '100%' }}
                    className={Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #ffd54f, #ffb74d, #ffa726, #fb8c00)" }} >
                                <ListAltIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Labs.UserNodes.labInfo.list.quizScore')} primary={`${props.quizScore}/10`} />
                    </ListItem>
                </Paper>
            </Tooltip>
            <Tooltip title={t('Labs.UserNodes.labInfo.tooltip.totalScore')}>
                <Paper elevation={3} sx={{ width: '100%' }} className={Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #64b5f6, #42a5f5, #2196f3, #1e88e5)" }}>
                                <EmojiEventsIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Labs.UserNodes.labInfo.list.totalScore')} primary={`${props.totalScore}/10`}
                        />
                    </ListItem>
                </Paper>
            </Tooltip>
            <Tooltip title={t('Labs.UserNodes.labInfo.tooltip.attempts')}>
                <Paper elevation={3} sx={{ width: '100%' }}
                    className={Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #81c784, #66bb6a, #4caf50, #43a047)" }} >
                                <ExtensionIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Labs.UserNodes.labInfo.list.attempts')} primary={`${props.attempts}/3`} />
                    </ListItem>
                </Paper>
            </Tooltip>
        </>
    );
}
